"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconEconomyFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 18 18",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M18,0 L0,0 L0,18 L18,18 L18,0 Z M6,14 L4,14 L4,7 L6,7 L6,14 Z M10,14 L8,14 L8,4 L10,4 L10,14 Z M14,14 L12,14 L12,10 L14,10 L14,14 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconEconomyFilled')(IconEconomyFilled);